import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { useFilters } from '@hooks/useFilters';
import styles from './AppliedFilters.module.css';

export const AppliedFilters: FC = () => {
    const { appliedFilters, removeFilter, removeAllFilters } = useFilters();
    const { t } = useTranslation();

    const translations = {
        appliedFilters: t('applied-filters-components.count-filters'),
        cleanButton: t('applied-filters-components.clean-button'),
    };

    const appliedFiltersToDisplay = appliedFilters.filter((item) => item.values.map((item) => item.name).join(', ') !== '');

    return (
        <>
            {appliedFiltersToDisplay.length > 0 && (
                <div className={`${styles['applied-filters-container']} mb-5`}>
                    <Typography fontSize="16" classes="mb-0">
                        <>
                            {appliedFiltersToDisplay.length} {translations.appliedFilters}&nbsp;
                            <button type="button" className={styles['clear-filters']} onClick={removeAllFilters}>
                                {translations.cleanButton}
                            </button>
                        </>
                    </Typography>
                    {appliedFiltersToDisplay.map((filter, index) => {
                        const values = filter.values.map((item) => item.name).join(', ');
                        const filterDisplay = `${filter.label}: ${values}`;

                        return (
                            <div className={styles['applied-filter']} key={`filter-${index}`}>
                                <Typography tagVariant={TypographyTagVariants.span}>{filterDisplay}</Typography>
                                <button type="button" onClick={() => removeFilter(filter.label)}>
                                    <Typography tagVariant={TypographyTagVariants.span}>
                                        <i className="fa-light fa-xmark" />
                                    </Typography>
                                </button>
                            </div>
                        );
                    })}
                </div>
            )}
        </>
    );
};
